// SYM-6267. The editor opens the sidebar tab for a clicked canvas object a
// moment later, so the click does not turn into a drag. Only one opening can
// be pending: a new selection or a deselection cancels it, and it is skipped
// when the object is no longer selected by the time it fires. Without this
// the tab could open for an object that is gone and crash the sidebar.
export const createDelayedTabOpener = (delayMs: number) => {
  let timer: ReturnType<typeof setTimeout> | undefined;

  const cancel = () => {
    if (timer !== undefined) clearTimeout(timer);
    timer = undefined;
  };

  const open = (isStillSelected: () => boolean, openTab: () => void) => {
    cancel();
    timer = setTimeout(() => {
      timer = undefined;
      if (isStillSelected()) openTab();
    }, delayMs);
  };

  return { open, cancel };
};
